import moment from "moment-timezone";

export default function offsetInterval(
  interval: ScheduleInterval,
  days: number,
  timezone: TimeZone,
) {
  if (!interval || days === 0) {
    return interval;
  }

  let res = interval;
  ["start_time", "end_time"].forEach((k) => {
    const oldTime = moment(interval[k]).tz(timezone);
    const oldHour = oldTime.hour();
    // recheck if the same hour
    // dont use clone, some weird issue
    const newTimeStr = moment(interval[k])
      .tz(timezone)
      .add(days, "d")
      .hour(oldHour)
      .toISOString();
    res = {
      ...res,
      [k]: newTimeStr,
    };
  });

  return res;
}
